import { SEED_REPEATERS } from './';

export default (parentKey, id, seedKeys, purge = false) => ({
  type: SEED_REPEATERS,
  payload: { parentKey, childId: id, seedKeys, purge },
});
